import { Subscribe } from '@react-rxjs/core';
import { FC, useState } from 'react';
import { AssignationModal } from '../../components/AssignationModal';
import { DelayUnmount } from '../../components/DelayUnmount';
import { ShellContent } from '../../components/Shell';
import {
  Assignation,
  InspectionNotifications,
  DefaultTripType,
  PrivateMileage,
  CurrentStatusFeature,
} from './views';
import { DoorLock } from './DoorLock';

interface MainProps {}

export const Main: FC<MainProps> = () => {
  const [assignOpen, setAssignOpen] = useState(false);

  return (
    <ShellContent>
      <Subscribe fallback={null}>
        <InspectionNotifications />
        <CurrentStatusFeature />
        <Assignation onAssign={() => setAssignOpen(true)} />
        <DoorLock />
      </Subscribe>
      <DefaultTripType />
      <PrivateMileage />
      <DelayUnmount unmount={!assignOpen}>
        <AssignationModal
          open={assignOpen}
          onClose={() => setAssignOpen(false)}
        />
      </DelayUnmount>
    </ShellContent>
  );
};
